// ---------------------------------------------------------------------------
// Rocket nozzle types and defaults
// ---------------------------------------------------------------------------

export const ft2El = (
  <>
    {'[Ft.'}
    <sup>{'2'}</sup>
    {']'}
  </>
);

export type InputKey =
  | 'At_ft2'
  | 'AeAt'
  | 'AiAt'
  | 'Pt_psi'
  | 'P0_psi'
  | 'Tt_F'
  | 'gamma'
  | 'MW';

export interface InputField {
  key: InputKey;
  label: React.ReactNode;
  unit: React.ReactNode;
  defaultValue: string;
  geometryOnly?: boolean;
}

export const inputFields: InputField[] = [
  {
    key: 'At_ft2',
    label: (
      <>
        {'Throat Area (A'}
        <sub>{'t'}</sub>
        {')'}
      </>
    ),
    unit: ft2El,
    defaultValue: '0.99903',
  },
  {
    key: 'AeAt',
    label: (
      <>
        {'Expansion Ratio ε (A'}
        <sub>{'e'}</sub>
        {'/A'}
        <sub>{'t'}</sub>
        {')'}
      </>
    ),
    unit: '[-]',
    defaultValue: '50.0',
  },
  {
    key: 'AiAt',
    label: (
      <>
        {'Converging Section (A'}
        <sub>{'i'}</sub>
        {'/A'}
        <sub>{'t'}</sub>
        {')'}
      </>
    ),
    unit: '[-]',
    defaultValue: '3.9925',
    geometryOnly: true,
  },
  {
    key: 'Pt_psi',
    label: (
      <>
        {'Chamber Pressure (P'}
        <sub>{'t'}</sub>
        {')'}
      </>
    ),
    unit: '[PSI]',
    defaultValue: '1999.2',
  },
  {
    key: 'P0_psi',
    label: (
      <>
        {'Ambient Pressure (P'}
        <sub>{'0'}</sub>
        {')'}
      </>
    ),
    unit: '[PSI]',
    defaultValue: '14.7',
  },
  {
    key: 'Tt_F',
    label: (
      <>
        {'Stagnation Temp (Tt'}
        <sub>{'0'}</sub>
        {')'}
      </>
    ),
    unit: '[°F]',
    defaultValue: '4000',
  },
  {
    key: 'gamma',
    label: 'Specific Heats γ',
    unit: '[-]',
    defaultValue: '1.293',
  },
  {
    key: 'MW',
    label: 'Molecular Weight',
    unit: '[g/mol]',
    defaultValue: '28.97',
  },
];

export type InputState = Record<InputKey, string>;

export const defaultInputs: InputState = Object.fromEntries(
  inputFields.map((f) => [f.key, f.defaultValue]),
) as InputState;

// parseNum / fmt were byte-identical to parameterArea/rocketNozzleFields.tsx;
// both now share one copy in src/lib/physics (issue #128). Re-exported here
// for back-compat with existing importers.
export { parseNum, fmt } from '@/lib/physics/rocketNozzleOutputs';
